import { withRouter } from 'react-router-dom'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl, FormattedMessage } from 'react-intl'
import { Button, Portal } from '@material-ui/core'
import isEqual from 'lodash/isEqual'
import cn from 'classnames'
import { List } from 'immutable'
import ConfirmDialog from 'components/common/Popup/ConfirmDialog'
import Loading from 'components/Loading'
import { TABLET_BREAKPOINT } from 'helpers/responsive'
import {
  fetchJobList,
  fetchJobTaskList,
  fetchJobFiltersData,
  updateJob,
  resetTasks,
  resetData,
  updateJobTask,
} from 'reducers/myJobs/reducer'
import { saveMyJobsFilters } from 'reducers/profile/reducer'
import ifWindowWidthLessThan from 'helpers/ifWindowWidthLessThan'
import withPromise from 'helpers/withPromise'
import {
  COMPLETE_ITEM,
  PENDING,
  REOPEN_ITEM,
  SEND_BACK_FROM_REVIEW,
  SEND_FOR_REVIEW,
  STATUS_COMPLETED,
} from 'helpers/jobs'
import FuncHelper from 'helpers/functions'
import Psfs from 'lib/psfs/Psfs'
import { showNotice } from 'reducers/notice'
import Loader from 'components/Loading/SmallLoader'
import RoleHelper from 'helpers/role'
import messages from '../translate'
import JobTask from '../JobTask/JobTask'
import JobItem from './JobItem'
import { FILTER_NAMES, PAGE_SIZE } from '../Common/constants'
import { getExistedValue } from '../Common/utils'

class JobList extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isConfirmDialogOpen: false,
      activeJobId: null,
      activeTaskId: null,
      activeTask: {},
      activeJob: null,
      activeSite: null,
      loaded: {},
      popupTitle: '',
      popupMessage: '',
      popupAction: FuncHelper.emptyFunc,
      disabledBtn: false,
      tasksData: {},
      isScrolled: false,
      isNewJob: false,
      invalidSingleInput: false,
      valueOutOfRange: false,
      isFocused: false,
      isNextTaskActive: false,
    }

    this.tasksOffsetTopPosition = {}
  }

  componentDidMount() {
    this.fetchJobList()
  }

  // eslint-disable-next-line max-statements
  componentDidUpdate(prevProps, prevState) {
    const {
      activeJobId,
      activeJob: prevActiveJob,
      invalidSingleInput,
      isFocused,
      valueOutOfRange,
    } = this.state
    const {
      resetData,
      myJobsFilters,
      isReloadJobList,
      jobList,
      jobTask,
      isPortalActive,
      resetTasks,
      jobFilters,
      location,
      isLoadJobList,
      profileInfo,
    } = this.props
    const {
      myJobsFilters: prevMyJobsFilters,
      isReloadJobList: prevIsReloadJobList,
      jobList: prevJobList,
      jobTask: prevJobTask,
      isPortalActive: prevIsPortalActive,
      jobFilters: prevJobFilters,
    } = prevProps
    const query = new URLSearchParams(location.search)
    const job_id = query.get('job_id')
    const activeSite = myJobsFilters.toArray()[0]
    const prevActiveSite = prevMyJobsFilters.toArray()[0]
    const arrJobList = jobList.toArray()
    const prevArrJobList = prevJobList.toArray()
    const tasks = jobTask.get('tasks')
    const prevTasks = prevJobTask.get('tasks')
    const checkTasks =
      tasks &&
      prevTasks &&
      tasks.length > 0 &&
      tasks.length === prevTasks.length
    const tasksStates = []
    const prevTasksStates = []
    const tasksTitles = []
    const prevTasksTitles = []

    if (
      activeJobId &&
      prevIsPortalActive !== isPortalActive &&
      !isPortalActive
    ) {
      this.setState({ activeJobId: null })
    }

    if (
      location.search &&
      !isEqual(jobList, prevJobList) &&
      query.size &&
      jobList.size
    ) {
      this.setDefaultActiveJobAndTask()
    }

    // TODO resolve this issue
    // if (
    //   activeJobId &&
    //   prevActiveJob &&
    //   !arrJobList.find(({ id }) => id === activeJobId)
    // ) {
    //   this.setState({ activeJobId: null, activeJob: null })
    // }

    if (checkTasks) {
      tasks.forEach(task => {
        tasksStates.push(task.state)
        tasksTitles.push(task.title)
      })

      prevTasks.forEach(task => {
        prevTasksStates.push(task.state)
        prevTasksTitles.push(task.title)
      })
    }

    if (
      (tasks && !isEqual(tasks, prevTasks)) ||
      (tasks && invalidSingleInput !== prevState.invalidSingleInput) ||
      (tasks && isFocused !== prevState.isFocused) ||
      (tasks && valueOutOfRange !== prevState.valueOutOfRange)
    ) {
      let disabledBtn

      if (tasks.length === 1) {
        disabledBtn = invalidSingleInput || isFocused || valueOutOfRange
      } else {
        disabledBtn = tasks.some(
          item => !item.optional && item.state !== STATUS_COMPLETED,
        )
      }

      this.setState({ disabledBtn })
    }

    if (jobFilters.get('preset') !== prevJobFilters.get('preset')) {
      this.resetJobData()
    }

    const shouldReset =
      List.isList(prevActiveSite) && List.isList(activeSite)
        ? prevActiveSite.toArray()[0] !== activeSite.toArray()[0]
        : prevActiveSite !== activeSite
    if (shouldReset) {
      resetData()
      resetTasks()
    }

    if (isReloadJobList !== prevIsReloadJobList) {
      this.fetchJobList()
    }

    if (
      checkTasks &&
      !isEqual(tasksStates, prevTasksStates) &&
      isEqual(tasksTitles, prevTasksTitles)
    ) {
      const objJobTask = jobTask.toJS()
      const index = arrJobList.findIndex(({ id }) => id === objJobTask.id)

      if (index < PAGE_SIZE) {
        this.fetchJobList(true)
      }
    }

    if (job_id && arrJobList.length && !isLoadJobList && !activeJobId) {
      const jobMatch = arrJobList.find(job => job.id === +job_id)

      if (jobMatch) {
        this.onJobMoreInfoClick(jobMatch)
      }
    }

    if (
      activeJobId &&
      arrJobList.length &&
      prevState.activeJobId === activeJobId
    ) {
      const { state: prevJobState } =
        prevArrJobList.find(job => job.id === activeJobId) || {}
      const { state: jobState } =
        arrJobList.find(job => job.id === activeJobId) || {}

      if (jobState !== prevJobState) {
        this.setState({
          activeJob: {
            ...prevActiveJob,
            state: jobState,
          },
        })
      }
    }

    if (
      activeJobId &&
      arrJobList.length &&
      prevState.activeJobId !== activeJobId
    ) {
      const activeJob = arrJobList.find(job => job.id === activeJobId)

      if (activeJob) {
        this.setState({ activeJob })
      } else {
        this.setState(
          {
            activeJobId: null,
            activeJob: null,
            activeTaskId: null,
            activeTask: {},
          },
          () => resetTasks(),
        )
      }
    }

    if (activeJobId && prevState.activeJobId !== activeJobId) {
      this.setState({
        tasksData: {},
      })
    }

    if (
      arrJobList.length > 0 &&
      prevArrJobList.length > 0 &&
      (arrJobList.length > prevArrJobList.length ||
        (arrJobList.length === PAGE_SIZE &&
          prevArrJobList.length === PAGE_SIZE &&
          !isEqual(arrJobList, prevArrJobList)))
    ) {
      const addedJob = arrJobList.filter(
        job => !prevArrJobList.some(prevJob => prevJob.id === job.id),
      )

      if (
        addedJob.length === 1 &&
        (!activeJobId ||
          (addedJob[0].created_by &&
            profileInfo.toJS().id === addedJob[0].created_by.id))
      ) {
        const activeJob = arrJobList.find(job => job.id === addedJob[0].id)
        this.setState(
          {
            activeJobId: addedJob[0].id,
            ...(activeJob && { activeJob }),
            isScrolled: false,
            isNewJob: true,
          },
          () => {
            this.onJobMoreInfoClick(addedJob[0], true)
          },
        )
      }
    }
  }

  componentWillUnmount() {
    this.props.resetTasks()
  }

  fetchJobList = skipLoader => {
    const {
      fetchJobList,
      jobFilters,
      fetchJobFiltersData,
      page,
      setPage,
      searchValue,
      respectFilters,
      saveMyJobsFilters,
    } = this.props
    const { site, preset, units, sort, ...restFilters } = jobFilters.toJS()
    const psfs = new Psfs()
    psfs.addPagination(1, PAGE_SIZE)

    if (site) {
      withPromise(fetchJobFiltersData, { site }).then(data => {
        const sortedFilters = Object.keys(restFilters).reduce(
          (accumulator, key) => ({
            ...accumulator,
            [FILTER_NAMES[key]]: getExistedValue(
              restFilters[key],
              data[FILTER_NAMES[key]],
            ),
          }),
          {},
        )

        if (
          !isEqual(Object.values(restFilters), Object.values(sortedFilters))
        ) {
          saveMyJobsFilters({
            my_jobs_filters: sortedFilters,
          })
        }

        for (const key in restFilters) {
          if (
            Object.prototype.hasOwnProperty.call(restFilters, key) &&
            restFilters[key].length &&
            data[FILTER_NAMES[key]].some(({ id }) =>
              restFilters[key].includes(id),
            )
          ) {
            psfs.addFilter(key, restFilters[key], 'in')
          }
        }

        withPromise(fetchJobList, {
          params: {
            site,
            preset,
            sort,
            search: searchValue,
            respect_filters: +respectFilters,
            ...(!!units.length && {
              allowed_locuses_and_groups: JSON.stringify(units),
            }),
          },
          filters: { psfs },
          skipLoader,
        }).then(() => {
          if (page !== 1) {
            setPage(1)
          }
        })
      })
    }
  }

  fetchJobTaskList = skipLoader => {
    const { activeJobId } = this.state
    const { fetchJobTaskList } = this.props

    if (activeJobId) {
      fetchJobTaskList({
        activeJobId,
        skipLoader,
      })
    }
  }

  setDefaultActiveJobAndTask = () => {
    const { location, jobList } = this.props
    const { activeTaskId } = this.state
    const query = new URLSearchParams(location.search)

    const jobMatch = jobList
      .toJS()
      .find(
        ({ number, id }) =>
          id === +query.get('job_id') || number === +query.get('search'),
      )

    if (jobMatch && !jobMatch.future) {
      this.setState(
        {
          activeJobId: jobMatch.id,
          activeTaskId: +query.get('task_id') || activeTaskId,
        },
        () => {
          this.fetchJobTaskList()
        },
      )
    }
  }

  setInvalidSingleInput = value => {
    this.setState({
      invalidSingleInput: value,
    })
  }

  setIsFocused = value => {
    this.setState({
      isFocused: value,
    })
  }

  setOutOfRange = value => {
    this.setState({
      valueOutOfRange: value,
    })
  }

  onJobMoreInfoClick = job => {
    if (job.future) {
      return
    }

    const { onJobClick, scrollRef } = this.props
    const { activeJobId } = this.state
    if (ifWindowWidthLessThan(TABLET_BREAKPOINT)) {
      onJobClick(job)
    }

    if (!ifWindowWidthLessThan(TABLET_BREAKPOINT)) {
      if (scrollRef && scrollRef.current) {
        scrollRef.current.scrollTo({
          top: 0,
          behavior: 'smooth',
        })
      }
    }

    if (activeJobId !== job.id) {
      this.setState(
        {
          activeJobId: job.id,
          activeTaskId: null,
        },
        () => {
          this.fetchJobTaskList()
        },
      )
    } else {
      this.fetchJobTaskList()
    }
  }

  onJobTaskClick = id => {
    const { activeTaskId, isNextTaskActive } = this.state
    let checkActiveTask = null

    if (isNextTaskActive) {
      this.setState({
        isNextTaskActive: false,
      })

      return
    }

    if (activeTaskId !== id) {
      checkActiveTask = id
    }

    this.setState({
      activeTaskId: checkActiveTask,
    })
  }

  scrollToTaskPosition = (taskScrollPosition, delay = 0) => {
    const { scrollRef, portalRef } = this.props
    const scrollRefBox = ifWindowWidthLessThan(TABLET_BREAKPOINT)
      ? portalRef && portalRef.current
      : scrollRef && scrollRef.current

    if (!scrollRefBox) {
      return
    }

    setTimeout(() => {
      scrollRefBox.scrollTo({
        top: taskScrollPosition,
        behavior: 'smooth',
      })
    }, delay)
  }

  setTasksOffsetPosition = taskOffsetTop => {
    this.tasksOffsetTopPosition = {
      ...this.tasksOffsetTopPosition,
      ...taskOffsetTop,
    }
  }

  handleTaskStatusChange = action => {
    const { scrollRef } = this.props
    const scrollRefBox = scrollRef && scrollRef.current
    const refOffsetTop = scrollRefBox
      ? scrollRefBox.getBoundingClientRect().top
      : 0
    const { activeTaskId, tasksData } = this.state
    const { tasks } = this.props.jobTask.toJS()
    let nextActiveTaskId
    let activeItem
    let isNotLastItem
    let currentTaskPosition = ''
    const inProgressTasks = tasks.filter(
      task => task.state !== STATUS_COMPLETED,
    )
    const isActiveTaskExist = inProgressTasks.some(
      item => item.id === activeTaskId,
    )

    if (action !== 'complete') {
      currentTaskPosition =
        this.tasksOffsetTopPosition[activeTaskId] - refOffsetTop

      this.setState({
        tasksData: {
          ...tasksData,
          currentTaskPosition,
        },
      })

      return
    }

    if (isActiveTaskExist && inProgressTasks.length > 1) {
      inProgressTasks.forEach((task, index, arr) => {
        if (task.id === activeTaskId) {
          activeItem = index + 1

          if (inProgressTasks[activeItem]) {
            nextActiveTaskId = inProgressTasks[activeItem].id
            isNotLastItem = arr.indexOf(activeItem) < arr.length - 1
            currentTaskPosition =
              this.tasksOffsetTopPosition[nextActiveTaskId] - refOffsetTop
          }
        }
      })

      if (isNotLastItem) {
        this.setState({
          tasksData: {
            ...tasksData,
            currentTaskPosition,
            [activeTaskId]: 'close',
            [nextActiveTaskId]: 'open',
          },
          activeTaskId: nextActiveTaskId,
          isNextTaskActive: !!nextActiveTaskId,
        })
        this.scrollToTaskPosition(currentTaskPosition, 350)
      }
    }
  }

  handleButtonClick = params => {
    this.setState({
      ...params,
      isConfirmDialogOpen: true,
    })
  }

  handleClose = () => {
    this.setState({ isConfirmDialogOpen: false })
  }

  onJobTaskUpdate = async (action, id) => {
    const { updateJobTask } = this.props

    await withPromise(updateJobTask, {
      action,
      params: { id },
    }).then(res => {
      if (res && res.errors) {
        return Promise.resolve(res.errors)
      }
    })
  }

  onUpdate = async action => {
    const { activeJob } = this.state
    const {
      updateJob,
      handleReturn,
      resetTasks,
      jobTask,
      isJobUpdating,
    } = this.props

    const jobTaskInfo = jobTask.toJS()
    const { tasks } = jobTaskInfo

    if (isJobUpdating) {
      return
    }

    if (
      tasks.length === 1 &&
      (action === COMPLETE_ITEM || action === SEND_FOR_REVIEW) &&
      !tasks[0].optional &&
      tasks[0].state !== STATUS_COMPLETED
    ) {
      await this.onJobTaskUpdate(COMPLETE_ITEM, tasks[0].id)
    }

    withPromise(updateJob, {
      action,
      params: { id: activeJob.id },
      title: activeJob.title,
    }).then(res => {
      if (res && res.errors) {
        return Promise.resolve(res.errors)
      }

      if (tasks.length === 1 && !tasks[0].optional && action === REOPEN_ITEM) {
        this.onJobTaskUpdate(action, tasks[0].id)
      }

      this.fetchJobList()

      if (ifWindowWidthLessThan(TABLET_BREAKPOINT)) {
        handleReturn()
      } else {
        this.resetJobData()

        resetTasks()
      }
    })

    this.handleClose()
  }

  resetJobData = () => {
    this.setState({
      activeJob: null,
      activeJobId: null,
    })
  }

  renderSendBackButton = activeJob => {
    const { title = '', id = 0 } = activeJob || {}
    const {
      intl: { formatMessage },
    } = this.props

    const action = {
      popupAction: () => this.onUpdate(SEND_BACK_FROM_REVIEW),
      popupTitle: formatMessage(messages.sendBackFromReview),
      popupMessage: (
        <FormattedMessage
          {...messages.confirmJobMessage}
          values={{
            action: formatMessage(messages.sendBackFromReview).toLowerCase(),
            entry: <strong>{title}</strong>,
          }}
        />
      ),
    }

    return (
      <Button
        key={`${id}-send-back-from-review`}
        size="large"
        color="primary"
        variant="contained"
        type="button"
        className={cn('complete-job')}
        onClick={() => this.handleButtonClick(action)}>
        <span key="send-back-from-review-title">
          {formatMessage(messages.sendBackFromReview)}
        </span>
      </Button>
    )
  }

  renderButton = activeJob => {
    const { state, needs_approval: needsApproval, title = '', id = 0 } =
      activeJob || {}
    const { disabledBtn } = this.state
    const {
      intl: { formatMessage },
      profileInfo,
      roleLevel,
      featureFlags,
    } = this.props
    const { grantedReopenJobs } = profileInfo.toJS()

    let buttonContent
    let activeAction
    let actions
    const isStateCompleted = state === STATUS_COMPLETED
    const disabled = isStateCompleted ? !grantedReopenJobs : disabledBtn

    if (id) {
      actions = {
        reopen: {
          popupAction: () => this.onUpdate(REOPEN_ITEM),
          popupTitle: formatMessage(messages.reopenJob),
          popupMessage: (
            <FormattedMessage
              {...messages.confirmJobMessage}
              values={{
                action: formatMessage(messages.reopen).toLowerCase(),
                entry: <strong>{title}</strong>,
              }}
            />
          ),
        },
        complete: {
          popupAction: () => this.onUpdate(COMPLETE_ITEM),
          popupTitle: formatMessage(messages.completeJob),
          popupMessage: (
            <FormattedMessage
              {...messages.confirmJobMessage}
              values={{
                action: formatMessage(messages.complete).toLowerCase(),
                entry: <strong>{title}</strong>,
              }}
            />
          ),
        },
        sendForReview: {
          popupAction: () => this.onUpdate(SEND_FOR_REVIEW),
          popupTitle: formatMessage(messages.sendForReview),
          popupMessage: (
            <FormattedMessage
              {...messages.confirmJobMessage}
              values={{
                action: formatMessage(messages.sendForReview).toLowerCase(),
                entry: <strong>{title}</strong>,
              }}
            />
          ),
        },
      }
    }

    if (isStateCompleted) {
      activeAction = actions.reopen
      buttonContent = (
        <span key="job-reopen">{formatMessage(messages.reopenJob)}</span>
      )
    } else if (
      featureFlags?.JOBS_APPROVAL &&
      needsApproval &&
      state !== PENDING
    ) {
      activeAction = actions.sendForReview
      buttonContent = (
        <span key="job-send-for-review">
          {formatMessage(messages.sendForReview)}
        </span>
      )
    } else if (state !== PENDING || roleLevel >= RoleHelper.ROLE_ADMIN_LEVEL) {
      activeAction = actions.complete
      buttonContent = (
        <span key="job-complete">{formatMessage(messages.completeJob)}</span>
      )
    }

    return (
      <>
        <Button
          key={id}
          disabled={disabled}
          size="large"
          color="primary"
          variant="contained"
          type="button"
          className={cn('complete-job', { disabled })}
          onClick={() => this.handleButtonClick(activeAction)}>
          {buttonContent}
        </Button>
        {featureFlags?.JOBS_APPROVAL &&
          needsApproval &&
          state === PENDING &&
          roleLevel >= RoleHelper.ROLE_ADMIN_LEVEL &&
          this.renderSendBackButton(activeJob)}
      </>
    )
  }

  getJobTaskList = () => {
    const {
      jobTask,
      location,
      activeSite,
      myJobsFilters,
      profileInfo,
      isInfoModalOpen,
      handleCloseInfoModal,
    } = this.props
    const {
      activeTaskId,
      activeTask,
      activeJob,
      tasksData,
      isNextTaskActive,
    } = this.state
    const jobTaskInfo = jobTask.toJS()
    const { name } = profileInfo.toJS()
    const {
      tasks,
      allowed_locuses,
      allowed_locus_groups,
      state: jobState,
      trigger_preview_inputs,
    } = jobTaskInfo
    const isActiveJobExist = activeJob && Object.keys(activeJob).length > 0
    const activeJobStatus = isActiveJobExist && activeJob.state
    let originalTaskPosition = 0
    let currentTaskPosition = 0
    let duplicatedTaskPosition = 0

    const sortedTasks = []

    tasks.forEach(singleTask => {
      if (!singleTask.original_task_id) {
        const { id: currentTaskId } = singleTask
        const duplicates = tasks.filter(
          singleTask => singleTask.original_task_id === currentTaskId,
        )

        sortedTasks.push(singleTask)

        if (duplicates.length) {
          duplicates.forEach(item => {
            sortedTasks.push(item)
          })
        }
      }
    })

    return sortedTasks.map((taskInfo, index) => {
      const { id, position, original_task_id, state } = taskInfo
      const nextTaskInfo = sortedTasks[index + 1]
      const nextOriginalTaskId = nextTaskInfo && nextTaskInfo.original_task_id
      const isNextTaskDuplicable =
        nextOriginalTaskId === id && !original_task_id
      const isCurrentTaskDuplicated =
        original_task_id && originalTaskPosition === position

      if (!isCurrentTaskDuplicated) {
        currentTaskPosition = Number(Math.trunc(currentTaskPosition)) + 1
        duplicatedTaskPosition = 0
      }

      if (isNextTaskDuplicable || isCurrentTaskDuplicated) {
        currentTaskPosition = `${Math.trunc(
          currentTaskPosition,
        )}.${(duplicatedTaskPosition += 1)}`
      }

      originalTaskPosition = position
      const isSingleTask =
        sortedTasks.length === 1 &&
        !(state === STATUS_COMPLETED && jobState !== STATUS_COMPLETED)

      return (
        <JobTask
          {...taskInfo}
          key={`${taskInfo.id}${index}`}
          index={currentTaskPosition}
          triggeredInstructions={
            index === 0 &&
            trigger_preview_inputs &&
            trigger_preview_inputs.length
              ? trigger_preview_inputs
              : undefined
          }
          activeTask={activeTaskId}
          isNextTaskActive={isNextTaskActive}
          prevTask={activeTask}
          activeJobStatus={activeJobStatus}
          activeJob={activeJob}
          activeSite={activeSite}
          locusList={allowed_locuses}
          locusGroupList={allowed_locus_groups}
          myJobsFilters={myJobsFilters}
          profileName={name}
          tasksData={tasksData}
          location={location}
          isInfoModalOpen={isInfoModalOpen}
          isSingleTask={isSingleTask}
          onJobTaskClick={this.onJobTaskClick}
          onJobTaskListRefresh={this.fetchJobTaskList}
          onJobListRefresh={this.fetchJobList}
          handleTaskStatusChange={this.handleTaskStatusChange}
          handleCloseInfoModal={handleCloseInfoModal}
          setTasksOffsetPosition={this.setTasksOffsetPosition}
          scrollToTaskPosition={this.scrollToTaskPosition}
          setInvalidSingleInput={this.setInvalidSingleInput}
          setIsFocused={this.setIsFocused}
          setOutOfRange={this.setOutOfRange}
        />
      )
    })
  }

  handleScrollChange = isScrolled => {
    this.setState({ isScrolled })
  }

  render() {
    const {
      isLoadJobList,
      isLoadTaskList,
      jobList,
      jobTask,
      portalRef,
      isPortalActive,
      profileInfo,
      previewInputs,
      isJobUpdating,
      intl: { formatMessage },
      isLoadJobInput,
    } = this.props
    const {
      activeJobId,
      activeJob,
      popupAction,
      popupMessage,
      popupTitle,
      isScrolled,
      isNewJob,
      isConfirmDialogOpen,
      disabledBtn,
    } = this.state
    const { tasks } = jobTask.toJS()
    const { ...info } = profileInfo.toJS()
    const checkTasksList = tasks && tasks.length > 0
    const isActiveJobExist = activeJob && Object.keys(activeJob).length > 0

    return (
      <div className="job-container-box">
        <div className="job-list">
          {jobList.map(jobItem => (
            <JobItem
              key={jobItem.id}
              jobItem={jobItem}
              activeJobId={activeJobId}
              createdBy={
                jobItem.created_by || jobItem.created_by_trigger_rule || {}
              }
              profileInfo={info}
              isScrolled={isScrolled}
              isNewJob={isNewJob}
              previewInputs={previewInputs}
              handleScrollChange={this.handleScrollChange}
              resetJobData={this.resetJobData}
              reloadJobList={this.fetchJobList}
              onJobMoreInfoClick={this.onJobMoreInfoClick}
              disabledBtn={disabledBtn}
            />
          ))}
        </div>
        {!ifWindowWidthLessThan(TABLET_BREAKPOINT) && (
          <div className="task-list">
            {checkTasksList && activeJob && (
              <>
                {this.getJobTaskList()}
                {this.renderButton(activeJob)}
              </>
            )}
          </div>
        )}
        {ifWindowWidthLessThan(TABLET_BREAKPOINT) && isPortalActive && (
          <Portal container={portalRef.current}>
            <div className="task-list">
              {checkTasksList && activeJob && (
                <>
                  {this.getJobTaskList()}
                  {this.renderButton(activeJob)}
                </>
              )}
            </div>
          </Portal>
        )}
        {isActiveJobExist && (
          <ConfirmDialog
            className="confirm-action dialog-primary-custom"
            open={isConfirmDialogOpen}
            title={popupTitle}
            message={popupMessage}
            onClose={this.handleClose}
            onConfirmAction={popupAction}
            cancel={{
              color: 'default',
              variant: 'outlined',
              customText: formatMessage(messages.cancel),
            }}
            confirm={{
              color: 'scales-primary',
              variant: 'text',
              customText: isJobUpdating ? (
                <Loader />
              ) : (
                formatMessage(messages.yes)
              ),
            }}
          />
        )}
        {(isLoadJobList ||
          isLoadTaskList ||
          isJobUpdating ||
          isLoadJobInput) && <Loading pastDelay />}
      </div>
    )
  }
}

export default connect(
  state => ({
    myJobsFilters: state.getIn(['profile', 'myJobsFilters']),
    isLoadJobList: state.getIn(['myJobs', 'isLoadJobList']),
    isLoadTaskList: state.getIn(['myJobs', 'isLoadTaskList']),
    isReloadJobList: state.getIn(['myJobs', 'isReloadJobList']),
    jobFilters: state.getIn(['myJobs', 'jobsFilters']),
    jobList: state.getIn(['myJobs', 'jobList']),
    jobTask: state.getIn(['myJobs', 'jobTask']),
    activeSite: state.getIn(['profile', 'myJobsFilters', 'site']),
    roleLevel: state.getIn(['profile', 'roleLevel']),
    profileInfo: state.getIn(['profile', 'profile']),
    previewInputs: state.getIn(['myJobs', 'previewInputs']),
    isJobUpdating: state.getIn(['myJobs', 'isJobUpdating']),
    isLoadJobInput: state.getIn(['myJobs', 'isLoadJobInput']),
    featureFlags: state.getIn(['profile', 'profile', 'featureFlags']),
  }),
  {
    fetchJobList,
    fetchJobTaskList,
    fetchJobFiltersData,
    resetData,
    updateJob,
    resetTasks,
    saveMyJobsFilters,
    updateJobTask,
    showNotice,
  },
)(injectIntl(withRouter(JobList)))
